import React from "react";

export default function AboutMe() {
    return (
        <section id="AboutMe" className="about--section">
            <div className="about--section--img">
                <img src="./img/about-me-new.png" alt="AboutMe"></img>
            </div>
            <div className="hero--section--content--box about--section--box">
                <div className="hero--section--content">
                    <h1 className="skills--section--heading">About Me</h1>
                    <p className="hero--section-descrition">4+ Years of Software Development Experience.</p>
                    <p className="hero--section-descrition">Passionate and innovative Software Engineer holding a Master's in Computer and Information Sciences from the university of Texas at Arlington. </p>
                    <p className="hero--section-descrition">Demonstrating mastery in Java, Python and Web Technologies, my career encompasses impactful roles across diverse companies, showcasing expertise in project implementation and optimization. Adept at collaborative development, I have contributed to diverse projects to pushing boundaries in software innovation..</p>
                </div>
            </div>
        </section>
    );
}